module.exports = __webpack_public_path__ + "static/dys-ab6e643363fddbb44df79c4988fa1c36.png";